import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { useBorrowerManagementAgreementFile } from '../../../../queries/BorrowerFields/PmcFields';

interface ManagementAgreementFileParameter {
    required: boolean;
    isReview?: boolean;
}

export const ManagementAgreementFile: React.FC<ManagementAgreementFileParameter> = ({ required, isReview = false }) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = useBorrowerManagementAgreementFile();

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Management Agreement'
                    selector='managementAgreement'
                    fileType={'management agreement'}
                    required={required}
                    isReview={isReview}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
